import { Box, Button, Grid, IconButton, Modal, Typography, useMediaQuery, } from '@mui/material';
import React from 'react'
import CancelIcon from '@mui/icons-material/Cancel';
import ConfirmationTick from '../icons/ConfirmationTick.svg'

interface ConfirmationDialogProps {
    open: boolean;
    handleClose: (event: React.MouseEvent<HTMLButtonElement>) => void
    title: string;
    text: string;
    buttonText: string;
}


export default function ConfirmationDialog(props: ConfirmationDialogProps) {
    const matches600 = useMediaQuery("(max-width:600px)");
    return (
        <div>
            <Modal
                open={props.open}
            >
                <Box sx={{
                    position: 'absolute' as 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 472,
                    height: matches600 ? "100%" : 523,
                    bgcolor: '#FFFFFF',
                    borderRadius: '4px',
                    boxShadow: 24,
                    display: 'flex',
                    flexDirection: 'column',
                    outline: 'none',
                    padding:'10px'
                }}>
                    <Grid item>
                        <Grid item sx={{display:'flex'}}>
                            <Grid xs={9.5} item sx={{ display: 'flex', justifyContent: 'flex-end', alignItems:'center'}}>
                                <Typography
                                    align='center'
                                    sx={{
                                        fontWeight: 600,
                                        fontSize: "18px",
                                        lineHeight: "22px",
                                        fontFamily: "Work Sans",
                                    }}
                                    p={1}>
                                    {props.title}
                                </Typography>
                            </Grid>
                            {
                                matches600 ? (<></>) : (
                                    <Grid item xs={2.5} sx={{ display: 'flex', justifyContent: 'flex-end',}}>
                                        <IconButton sx={{ color: '#39A2DB' }} onClick={props.handleClose}>
                                            <CancelIcon />
                                        </IconButton>
                                    </Grid>)
                            }
                        </Grid>
                    </Grid>
                    <Grid item xs={12} p={2} sx={{ display: 'flex', flexDirection: 'column' }}>
                        <Grid item pb={8} pt={2} sx={{ display: 'flex', justifyContent: 'center', }}>
                            <img src={ConfirmationTick} alt='confirmation' />
                        </Grid>
                        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'center' }}>
                            <Typography
                                align='center'
                                sx={{
                                    fontWeight: 400,
                                    fontSize: "18px",
                                    lineHeight: "22px",
                                    fontFamily: "Work Sans",
                                }}
                                p={1}>
                                {props.text}
                            </Typography>
                        </Grid>
                        <Grid pt={2} item xs={12} sx={{ display: 'flex', justifyContent: 'center', }}>
                            <Button
                                variant="contained"
                                style={{
                                    width: "111px",
                                    height: "42px",
                                    borderRadius: "24px",
                                    textTransform: "capitalize",
                                    color: 'white',
                                    backgroundColor: "#39A2DB",
                                    borderColor: "#39A2DB",
                                }}
                                onClick={props.handleClose}
                            >
                                {props.buttonText}
                            </Button>
                        </Grid>
                    </Grid>

                </Box>
            </Modal>
        </div>
    );
}
